import React, { useState } from 'react';
import { FiEdit2 } from "react-icons/fi";
import { HiOutlineChartSquareBar } from "react-icons/hi";
import { MdUpdate, MdPauseCircleOutline, MdPlayCircleOutline } from "react-icons/md";
import { FaRegStopCircle } from "react-icons/fa";

export default function CardIrrigacao() {

    const [displayed, setDisplayed] = useState(false);

    function handledisplay() {
        setDisplayed(!displayed);
    }
    return (
        <div className={displayed ? 'selectedcardirrigacao' : 'cardirrigacao'} style={{height: !displayed ? "33px" : ''}}>
            <div className="headerirrigacao">
                <div className="labelirrigacao"  onClick={() => handledisplay()}>
                    <label className="labelmotor"><b>MOTOR:</b> 10502 / <b>IMP:</b> 5898</label>
                </div>
                <div className="iconsheaderirrigacao">
                    <div className="iconirrigacao" >
                        <FiEdit2 size="30" />
                    </div>
                    <div className="iconirrigacao">
                        <HiOutlineChartSquareBar size="30" />
                    </div>
                    {/* <div className="iconirrigacao" onClick={() => handledisplay()}>
                        <MdExposure size="20" />
                    </div> */}
                </div>
            </div>
            <div className="contentirrigacao" style={{display: !displayed ? "none" : ''}}>
                <div className="contentsa">
                    <p className="contentslbl"><b>STATUS:</b></p>
                    <p className="contentslbl"><b>ATIVIDADE:</b></p>
                    <p className="contentslbl"><b>VELOCIDADE:</b></p>
                    <p className="contentslbl"><b>MANG. EST(m):</b></p>
                    <p className="contentslbl"><b>PRESSAO(kg):</b></p>
                    <p className="contentslbl"><b>PROPRIEDADE:</b></p>
                    <p className="contentslbl"><b>TALHAO:</b></p>
                    <p className="contentslbl"><b>HIDRANTE:</b></p>
                    <p className="contentslbl"><b>INICIO:</b></p>
                    <p className="contentslbl"><b>FIM:</b></p>
                    <p className="contentslbl"><b>ULTIMA ATT.:</b></p>
                    <p className="contentslbl"><b>MANG. PUX(m):</b></p>
                </div>
                <div className="contentsb">
                    <p className="contentslbl">ASDFASDFAS</p>
                    <p className="contentslbl">-</p>
                    <p className="contentslbl">-</p>
                    <p className="contentslbl">-</p>
                    <p className="contentslbl">-</p>
                    <p className="contentslbl">-</p>
                    <p className="contentslbl">-</p>
                    <p className="contentslbl">-</p>
                    <p className="contentslbl">-</p>
                    <p className="contentslbl">-</p>
                    <p className="contentslbl">-</p>
                    <p className="contentslbl">-</p>
                </div>
                <div className="rodapeirrigacao">
                    <div className="iconirrigacao">
                        <MdUpdate size="30" />
                    </div>
                    <div className="iconirrigacao">
                        <MdPauseCircleOutline size="30" />
                    </div>
                    <div className="iconirrigacao">
                        <MdPlayCircleOutline size="30" />
                    </div>
                    <div className="iconirrigacao">
                        <FaRegStopCircle size="26" />
                    </div>
                </div>
            </div>

        </div>
    )

}